import { DeliveryStageBadge } from '@/components/deal/vehicle/delivery-stage/delivery-stage-badge';
import { DELIVERY_STAGE_FILTER_OPTIONS } from '@/components/deal/vehicle/delivery-stage/delivery-stage-options';
import type { DeliveryStage } from '@/models/types';
import { COMBO_BOX_OPTIONS } from '../combobox-popovers/all-filters-combobox-popover';
import DeliveryStageFiltersComboBoxPopover from '../combobox-popovers/delivery-stage-filters-combobox-popover';
import type {
  DeliveryStageFilterChipProps,
  DeliveryStageFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const DeliveryStageFilterChip = (props: DeliveryStageFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<DeliveryStage, DeliveryStageFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={DeliveryStageFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS.find((option) => option.value === 'delivery_stage')
          ?.icon
      }
      filterName="Delivery Stage"
      filterQuantifier={{ singular: 'stage', plural: 'stages' }}
      SelectedFilterBadge={DeliveryStageBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      getLabelForValue={(value) =>
        DELIVERY_STAGE_FILTER_OPTIONS.find((option) => option.value === value)
          ?.label as string | undefined
      }
    />
  );
};

export default DeliveryStageFilterChip;
